/// <reference path="../../typings/moment/moment.d.ts" />

import { Component, Input, Output, AfterViewInit, EventEmitter, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { StringExtensions } from "../utilities/string.extensions";
import { JqueryExtensionsService } from "../services/jquery.service";
import { DateExtensions } from "../utilities/date.extensions";
import { UserStorageService } from "../services/user-storage.service";

@Component({
  selector: "date-time-picker",
  template: `<div class="input-group date">
					<input type="text" [id]="id" class="form-control" [placeholder]="placeholder" [disabled]="disabled" [readonly]="editable">
					<div class="input-group-addon"><i class="fas fa-calendar-alt" aria-hidden="true"></i></div>
				</div>`
})
export class DateTimePickerComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() date = null;
  @Input() editable = "";
  @Input() disabled = false;
  @Input() placeholder = "";
  @Input() defaultDate = "";
  @Input() format = "ddd DD/MM/YY HH:mm";
  @Input() minDate = null;
  @Input() maxDate = null;
  @Input() viewMode = "days";
  @Input() useUserTimezone = true;
  @Output() dateTimePikerChanged: EventEmitter<Date> = new EventEmitter<Date>();
  id: string;

  private element: JQuery;
  private dateNow = new Date();
  private localOffset = this.dateNow.getTimezoneOffset();
  private timezoneOffset: string;
  private monthFormat: boolean;

  constructor(
    private jqueryService: JqueryExtensionsService,
    private userStorageService: UserStorageService
  ) { }

  ngOnInit() {
    if (!this.id) { this.id = "date-time-picker-" + StringExtensions.generateUUID(); }
    if (this.format == "MMMM YYYY") {
      this.monthFormat = true;
    } else {
      this.monthFormat = false;
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["date"] && changes["date"].currentValue && changes["date"].currentValue !== changes["date"].previousValue) {

      if (!this.useUserTimezone) {
        return;
      }

      let date: Date;
        if (this.timezoneOffset) {
          date = DateExtensions.addTimezoneOffset(new Date(changes["date"].currentValue), this.timezoneOffset || "");
        } else {
          if (this.userStorageService.user) {
            this.timezoneOffset = this.userStorageService.user.timeZoneOffset;
          }
          date = DateExtensions.addTimezoneOffset(new Date(changes["date"].currentValue), this.timezoneOffset || "");
        }
      if (!this.element)
        this.init();
      setTimeout(() => {
        $("#" + this.id).data("DateTimePicker").date(date);
        if (this.editable == "readonly") this.toggle();
        if (this.element && this.minDate != null && ( this.maxDate === null || this.minDate < this.maxDate)) {
          $("#" + this.id).data("DateTimePicker").minDate(DateExtensions.addTimezoneOffset(new Date(this.minDate!), this.timezoneOffset || ""));
        }
        if (this.element && this.maxDate != null && ( this.maxDate === null || this.minDate < this.maxDate)) {
          $("#" + this.id).data("DateTimePicker").maxDate(DateExtensions.addTimezoneOffset(new Date(this.maxDate!), this.timezoneOffset || ""));
        }
        this.dateTimePikerChanged.emit(this.monthFormat ? date : this.removeTimezoneOffset(date));
      });
    }
  }

  ngAfterViewInit() {
    if (!this.element)
      this.init();
  }

  public init() {
    setTimeout(() => {
      if (this.useUserTimezone && this.userStorageService.user) {
        this.timezoneOffset = this.userStorageService.user.timeZoneOffset;
      }
      this.element = this.jqueryService
        .dateTimePicker("#" + this.id, {
          defaultDate: this.defaultDate,
          date: this.date,
          format: this.format,
          viewMode: this.viewMode

        });
      this.jqueryService.eventOn(
        this.element,
        "dp.change",
        () => {
          let date = moment($("#" + this.id).val(), this.format).toDate();
          if (this.editable == "readonly") this.toggle();
          if (this.minDate != null && (this.maxDate === null || this.minDate < this.maxDate)) {
            $("#" + this.id).data("DateTimePicker").minDate(DateExtensions.addTimezoneOffset(new Date(this.minDate!), this.timezoneOffset || ""));
          }
          if (this.maxDate != null && (this.maxDate === null || this.minDate < this.maxDate)) {
            $("#" + this.id).data("DateTimePicker").maxDate(DateExtensions.addTimezoneOffset(new Date(this.maxDate!), this.timezoneOffset || ""));
          }
          this.dateTimePikerChanged.emit(this.monthFormat ? date : this.removeTimezoneOffset(date));
        }
      );
    });
  }

  public toggle() {
    $("#" + this.id).data("DateTimePicker").toggle();
  }

  removeTimezoneOffset(date: Date) {
    let newDate: Date;
    date.setMinutes(date.getMinutes() - this.localOffset);

    if (this.timezoneOffset) {
      newDate = DateExtensions.removeZoneOffset(date, this.timezoneOffset || "");
    } else {
      newDate = date;
    }

    return newDate;
  }
}
